<template>
  <div class="home">

 

 <h3>演讲比赛</h3>
<van-button plain type="primary" @click="toKecheng">购买课程</van-button>
 

  </div>
</template>

<script>
 export default {
  
  methods: {
      toKecheng:function(){
         this.$router.push({ path:'/ysj/course'  })
      }
},


}
</script>
